module.exports = __webpack_public_path__ + "media/assets/icons/phone-9553808c2045790e30e550f74b5bed2b.svg";